<template>
  <div>
<!--    <div class="titleSeekBar d-flex justify-end " v-if="$vuetify.breakpoint.mdAndUp">-->
<!--      <div>-->
<!--        مرحله-->
<!--        {{ currentStep }}-->
<!--        از 5-->
<!--      </div>-->
<!--    </div>-->
    <div class="seekBar">
      <div class="fillArea d-flex justify-end" :style="`width: ${currentStep}%`">
<!--        <div class="circle" v-if="$vuetify.breakpoint.mdAndUp"></div>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
    currentStep() {
      return this.$store.getters.getSeekBarUserJourney
    }
  },

}
</script>

<style scoped>

@media (min-width: 200px) and (max-width: 1000px) {
  .seekBar{
    position: fixed !important;
    top: 80px !important;

  }
}

.seekBar {
  width: 100% !important;
  border-radius: 0px !important;
  height: 6px !important;
  top: 0px;
  right: 0px !important;
  left: 0px !important;
  z-index: 10;
}

.fillArea {
  height: 6px !important;
  border-radius: 20px 0px 0px 20px !important;
}


.titleSeekBar {
  width: 80%;
  margin: 0px auto;

}

.circle {
  width: 10px;
  height: 10px;
  background: white;
  border-radius: 50%;
  margin-right: 5px;
  margin-left: 5px;
  margin-top: 4px;
}

.infoSeekbar {
  position: absolute;
  left: -3px;
  top: -25px;
  color: #424242;
  text-align: center;
  /* Body/Large/Medium18 */
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.seekBar {
  width: 80%;
  margin: 0px auto;
  height: 19px;
  background: #EAF0F6;
  border-radius: 20px;
  position: relative;
}

.fillArea {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  width: 25%;
  border-radius: 20px;
  background: #39C990;
  transition: all 0.3s;
}

</style>